"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHelmet = void 0;

var _HelmetTitle = require("./HelmetTitle");

var _HelmetDescription = require("./HelmetDescription");

var _HelmetHelper = require("./HelmetHelper");

var _slugify = require("../helpers/slugify");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getHelmetType = function getHelmetType(data, agencyDetail, pdpDetail) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$isAgencySrp = _ref.isAgencySrp,
      isAgencySrp = _ref$isAgencySrp === void 0 ? false : _ref$isAgencySrp;

  if ('agencyIds' in data.filters && data.filters.agencyIds) {
    // AGENCY DETAIL LISTING
    if (agencyDetail && Object.keys(agencyDetail).length) {
      return _HelmetHelper.HELMET_AGENCY_TYPE;
    }

    return _HelmetHelper.HELMET_AGENCY_NOT_FOUND_TYPE;
  }

  if (isAgencySrp) {
    return _HelmetHelper.HELMET_AGENCY_SRP_TYPE;
  }

  if (pdpDetail && 'listingId' in pdpDetail) {
    return _HelmetHelper.HELMET_PDP;
  }

  if (data.filters.propertyTypes === 'all' || data.filters.propertyTypes === 'All' || data.filters.propertyTypes.length === 0) {
    if (data.locations.length || data.geo && data.geo.l9) {
      return _HelmetHelper.HELMET_SRP_NO_PROP_TYPE;
    }

    return _HelmetHelper.HELMET_SRP_NO_PROP_NO_LOC_TYPE;
  }

  if (data.locations.length || data.geo && data.geo.l9) {
    return _HelmetHelper.HELMET_SRP_TYPE;
  }

  return _HelmetHelper.HELMET_SRP_NO_LOC_TYPE;
};

var getHelmet = function getHelmet() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      domain = _ref2.domain,
      lang = _ref2.lang,
      _ref2$seodata = _ref2.seodata,
      seodata = _ref2$seodata === void 0 ? {} : _ref2$seodata,
      locations = _ref2.locations,
      _ref2$agencyDetail = _ref2.agencyDetail,
      agencyDetail = _ref2$agencyDetail === void 0 ? {} : _ref2$agencyDetail,
      _ref2$count = _ref2.count,
      count = _ref2$count === void 0 ? 0 : _ref2$count,
      _ref2$isAPDP = _ref2.isAPDP,
      isAPDP = _ref2$isAPDP === void 0 ? false : _ref2$isAPDP,
      _ref2$moreDetail = _ref2.moreDetail,
      moreDetail = _ref2$moreDetail === void 0 ? {} : _ref2$moreDetail,
      _ref2$isAgencySrp = _ref2.isAgencySrp,
      isAgencySrp = _ref2$isAgencySrp === void 0 ? false : _ref2$isAgencySrp,
      _ref2$prtFilters = _ref2.prtFilters,
      prtFilters = _ref2$prtFilters === void 0 ? {} : _ref2$prtFilters,
      seoParams = _ref2.seoParams,
      _ref2$pageType = _ref2.pageType,
      pageType = _ref2$pageType === void 0 ? 'TransactionPage' : _ref2$pageType,
      isSrpUrl = _ref2.isSrpUrl;

  var data = {
    channel: _HelmetHelper.TR_ENCODED[lang][seodata.tr || seodata.queryObject.tr] || undefined,
    page: seodata.page || seodata.queryObject.page || 1,
    locations: locations,
    features: seodata.features || [],
    filters: {
      agentCategory: seodata.publisher || 'all',
      category: seodata.propertyTypeGroup || seodata.category,
      features: {
        interiorFeatures: [],
        exteriorFeatures: []
      },
      landSize: {
        minimum: seodata.mqMin || seodata.queryObject.mqMin || 'any',
        maximum: seodata.mqMax || seodata.queryObject.mqMax || 'any'
      },
      minimumBathroom: seodata.numBaths || 'any',
      minimumCars: seodata.numParkingSpaces || 'any',
      onlyWithPhoto: seodata.queryObject.photo || false,
      priceRange: {
        minimum: seodata.price && seodata.price.from ? seodata.price.from : seodata.queryObject.priceMin || 'any',
        maximum: seodata.price && seodata.price.to ? seodata.price.to : seodata.queryObject.priceMax || 'any'
      },
      propertyTypes: seodata.propertyTypes || [],
      roomsRange: {
        minimum: seodata.numRoomsMin || seodata.queryObject.numRoomsMin || 'any',
        maximum: seodata.numRoomsMax || seodata.queryObject.numRoomsMax || 'any'
      },
      surroundingSuburbs: seodata.queryObject.surrounding || seodata.queryObject.includeSurrounding || false,
      availability: seodata.availability,
      balcony: seodata.balcony,
      buildingCondition: seodata.buildingCondition,
      buildingYearRange: {
        min: seodata.buildingYearMin || seodata.queryObject.buildingYearMin || 'any',
        max: seodata.buildingYearMax || seodata.queryObject.buildingYearMax || 'any'
      },
      energyClass: seodata.energyClass,
      garden: seodata.garden,
      heatingType: seodata.heatingType,
      level: seodata.level,
      lift: seodata.lift,
      photo: seodata.photo,
      terrace: seodata.terrace,
      agencyIds: seodata.publisherId,
      poi: seodata.poi,
      license_type_groups: seodata.license_type_groups || []
    },
    sortType: seodata.queryObject.sortType || null,
    // le ricerche ordinate per prezzo o superficie hanno ora valenza SEO
    agencyFt: prtFilters.agencyName
  };
  var pdpDetail = {};

  if (isAPDP) {
    pdpDetail = seodata;

    if (moreDetail) {
      pdpDetail.listingId = moreDetail.listingId || null;
      pdpDetail.propertyType = moreDetail.propertyType ? (0, _slugify.slugify)(moreDetail.propertyType) : null;
      pdpDetail.channel = moreDetail.channel || null;
      pdpDetail.address = moreDetail.address || null;
      pdpDetail.zone = moreDetail.zone || null;
      pdpDetail.city = moreDetail.city || null;
      pdpDetail.rooms = moreDetail.rooms || null;
      pdpDetail.mq = moreDetail.mq || null;
      pdpDetail.floor = moreDetail.floor || null;
      pdpDetail.isAChildOfProjectProfile = moreDetail.isAChildOfProjectProfile || false;
      pdpDetail.priceRange = moreDetail.priceRange || null;
      pdpDetail.licenseType = moreDetail.licenseType || null;
    }
  }

  var helmetType = getHelmetType(data, agencyDetail, pdpDetail, {
    isAgencySrp: isAgencySrp
  });
  var pageDescr = data.page > 1 ? " - pagina ".concat(data.page) : '';
  var title = (0, _HelmetTitle.getTitle)(domain, lang, helmetType, data, agencyDetail, pdpDetail, true, moreDetail || {});
  title = title.replace(/  +/g, ' ');
  var alias = (0, _HelmetTitle.getAlias)(_objectSpread({}, data));
  var description = (0, _HelmetDescription.getDescription)(domain, helmetType, data, agencyDetail, count, {
    alias: alias
  });
  description = description ? description.replace(/  +/g, ' ') : '';
  var h1 = (0, _HelmetTitle.getTitle)(domain, lang, helmetType, data, agencyDetail, pdpDetail, false, {}); // const aliasH2 = getAliasH2({ alias });

  var aliasH2 = alias || '';
  h1 = h1.replace(/\- Casa.it/gi, '').trim();
  h1 = h1.replace(/  +/g, ' ');
  var h2 = title.replace(h1, "");
  h2 = h2.replace(/\- Casa.it/gi, '').trim();
  title = "".concat(title).concat(pageDescr);
  h1 = "".concat(h1).concat(h2 === '' ? pageDescr : '');
  h2 = "".concat(h2).concat(h2 !== '' ? pageDescr : '');
  var robots = (0, _HelmetTitle.getRobots)({
    data: data,
    seoParams: seoParams,
    locations: locations,
    pageType: pageType,
    isSrpUrl: isSrpUrl,
    count: count
  }); // count > 0 && parseInt(data.page, 10) === 1 ? 'index, follow' : 'noindex,follow';

  var result = Object.assign({
    title: title,
    h1: h1,
    h2: h2,
    aliasH2: aliasH2,
    meta: {
      description: {
        name: 'description',
        content: description
      },
      robots: {
        name: 'robots',
        content: robots
      }
    }
  });
  return result;
};

exports.getHelmet = getHelmet;